/* ==========================================================================
   KTS Vinyl Storage Calculator v9 — Alpine component (T1 S2)
   v8 + pure jsPDF text PDF (no html2canvas — deterministic render).
   Exposes window.ktsStorageCalc() for x-data.
   ========================================================================== */
(function () {
  'use strict';

  var SPINE_MM  = { lp:3.2, lp180:4.1, gate:5.8, ep12:3.2, lp10:2.8, lp7:1.9 };
  var WEIGHT_KG = { lp:0.21, lp180:0.27, gate:0.24, ep12:0.18, lp10:0.14, lp7:0.07 };
  var VALUE_USD_PER_RECORD = 22;

  // Product catalog (unchanged from v5)
  var PRODUCTS = {
    starter: [
      { handle: 'vinyl-record-crate-open-top-vinyl-storage-50-60-lps',      name: 'Vinyl Record Crate',       capacity: 60,  price: 49.99,  img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/Vinyl_Record_Batea.jpg', alt: 'Vinyl Record Crate open-top storage by KTS' },
      { handle: 'flying-v-x2-double-wall-mounted-vinyl-display-100-120-lps', name: 'Flying V x2',              capacity: 120, price: 69.99,  img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/Flying_V_x2-01-1.jpg', alt: 'Flying V x2 wall-mounted vinyl display by KTS' },
      { handle: 'the-diggers-stack-complete-vinyl-station-150-lp-capacity', name: 'The Diggers Stack',         capacity: 150, price: 116.99, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/The_Digger_Stack_for_Vinyl_Record-13.jpg', alt: 'The Diggers Stack complete vinyl station by KTS' }
    ],
    growing: [
      { handle: 'vinyl-modular-x4-modular-vinyl-storage-system-200-lps',    name: 'Vinyl Modular x4',         capacity: 200, price: 198.00, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/VINYL-MODULAR-X4-4.jpg', alt: 'Vinyl Modular x4 storage system by KTS' },
      { handle: 'classic-box-x5-traditional-vinyl-storage-solution-for-serious-col', name: 'Classic Box x5',  capacity: 300, price: 189.99, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/Vinyl_Record_Box_x5-1.jpg', alt: 'Classic Box x5 traditional vinyl storage by KTS' },
      { handle: 'the-iroko-rack-complete-vinyl-station-170-lp-capacity-limited-edi', name: 'The Iroko Rack',   capacity: 170, price: 125.99, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/IrokoRack.jpg', alt: 'The Iroko Rack limited edition vinyl station by KTS' }
    ],
    enthusiast: [
      { handle: 'the-digger-s-wall-complete-vinyl-station-600-lp',          name: 'The Diggers Wall',         capacity: 600, price: 566.10, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/TheDiggersWall.jpg', alt: 'The Diggers Wall complete vinyl station by KTS' },
      { handle: 'vinyl-modular-x4-modular-vinyl-storage-system-200-lps',    name: 'Vinyl Modular x4 (×2)',    capacity: 400, price: 396.00, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/VINYL-MODULAR-X4-4.jpg', alt: 'Twin Modular x4 configuration by KTS' },
      { handle: 'modular-foreigner-combined-vinyl-storage-system-120-lps',  name: 'Modular Foreigner',        capacity: 120, price: 89.99,  img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/Modular-Foreigner-Salon.jpg', alt: 'Modular Foreigner combined vinyl storage by KTS' }
    ],
    serious: [
      { handle: 'the-digger-s-wall-complete-vinyl-station-600-lp',          name: 'Diggers Wall + Modular x4', capacity: 800, price: 764.10, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/TheDiggersWall.jpg', alt: 'Diggers Wall premium combo by KTS' },
      { handle: 'vinyl-modular-x4-modular-vinyl-storage-system-200-lps',    name: 'Vinyl Modular x4 (×4)',    capacity: 800, price: 792.00, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/VINYL-MODULAR-X4-4.jpg', alt: 'Quadruple Modular x4 setup by KTS' }
    ],
    dedicated: [
      { handle: 'the-digger-s-wall-complete-vinyl-station-600-lp',          name: 'Diggers Wall (×2) + Modular', capacity: 1400, price: 1330.20, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/TheDiggersWall.jpg', alt: 'Dedicated archive configuration by KTS' },
      { handle: 'vinyl-modular-x4-modular-vinyl-storage-system-200-lps',    name: 'Vinyl Modular x4 (×8)',    capacity: 1600, price: 1584.00, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/VINYL-MODULAR-X4-4.jpg', alt: 'Large modular archive setup by KTS' }
    ],
    archive: [
      { handle: 'the-digger-s-wall-complete-vinyl-station-600-lp',          name: 'Diggers Wall (×5) Library', capacity: 3000, price: 2830.50, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/TheDiggersWall.jpg', alt: 'Personal archive library by KTS' },
      { handle: 'vinyl-modular-x4-modular-vinyl-storage-system-200-lps',    name: 'Vinyl Modular x4 (×15)',   capacity: 3000, price: 2970.00, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/VINYL-MODULAR-X4-4.jpg', alt: 'Archive-scale modular by KTS' }
    ],
    library: [
      { handle: 'the-digger-s-wall-complete-vinyl-station-600-lp',          name: 'Custom Library Install',   capacity: 5000, price: 4500.00, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/TheDiggersWall.jpg', alt: 'Library-scale custom install by KTS' },
      { handle: 'vinyl-modular-x4-modular-vinyl-storage-system-200-lps',    name: 'Vinyl Modular Library',    capacity: 4000, price: 3960.00, img: 'https://cdn.shopify.com/s/files/1/0785/7415/8173/files/VINYL-MODULAR-X4-4.jpg', alt: 'Library-grade modular install by KTS' }
    ]
  };

  function tierForCount(n) {
    if (n <= 150)   return { key: 'starter',    label: 'Starter Setup',      units: 1 };
    if (n <= 350)   return { key: 'growing',    label: 'Growing Collection', units: 2 };
    if (n <= 600)   return { key: 'enthusiast', label: 'Enthusiast',         units: 2 };
    if (n <= 1000)  return { key: 'serious',    label: 'Serious Collector',  units: 3 };
    if (n <= 1800)  return { key: 'dedicated',  label: 'Dedicated Archive',  units: 4 };
    if (n <= 3500)  return { key: 'archive',    label: 'Personal Archive',   units: 6 };
    return            { key: 'library',    label: 'Library Scale',      units: 10 };
  }

  // ---- localStorage helpers (24h TTL) ----
  function cacheGet(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.t || Date.now() - obj.t > 86400000) {
        localStorage.removeItem(key); return null;
      }
      return obj.v;
    } catch (e) { return null; }
  }
  function cacheSet(key, value) {
    try { localStorage.setItem(key, JSON.stringify({ t: Date.now(), v: value })); } catch (e) {}
  }

  // ---- lazy loader for jsPDF (pure JS, no html2canvas) ----
  var _jspdfPromise = null;
  function loadJsPdf() {
    if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
    if (_jspdfPromise) return _jspdfPromise;
    _jspdfPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js';
      s.async = true;
      s.onload = function () {
        if (window.jspdf && window.jspdf.jsPDF) resolve(window.jspdf.jsPDF);
        else reject(new Error('jsPDF not available after load'));
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return _jspdfPromise;
  }

  function tr(k, fb) {
    var bag = window.KTS_TOOLCALC_I18N || {};
    return (k in bag) ? bag[k] : (fb || '');
  }

  function ktsStorageCalc() {
    return {
      tab: 'quick',
      quickCount: 250,
      detailed: { lp: 0, ep12: 0, lp10: 0, lp7: 0, pctHeavy: 0, pctGate: 0 },
      discogs: { username: '', loading: false, error: null, count: 0, success: false },
      embed: false,
      showSticky: false,
      result: {
        total: 0, meters: 0, feet: 0, inches: 0, kg: 0, lbs: 0, value: 0,
        tier: { key: '', label: '', units: 0, products: [] }
      },

      init: function () {
        // parse URL params for shareable state
        var p = new URLSearchParams(window.location.search);
        this.embed = p.get('embed') === '1';
        if (this.embed) document.body.classList.add('kts-embed');

        var tab = p.get('tab');
        if (tab && ['quick','detailed','discogs'].indexOf(tab) >= 0) this.tab = tab;

        var cnt = parseInt(p.get('records') || p.get('count'), 10);
        if (cnt && cnt > 0 && cnt < 50000) this.quickCount = cnt;

        ['lp','ep12','lp10','lp7','pctHeavy','pctGate'].forEach(function (k) {
          var v = parseInt(p.get(k), 10);
          if (!isNaN(v) && v >= 0) this.detailed[k] = v;
        }, this);

        var du = p.get('discogs');
        if (du) {
          this.discogs.username = du;
          this.tab = 'discogs';
          // try cache without firing a request
          var cached = cacheGet('kts_discogs_' + du.toLowerCase());
          if (cached && cached.count) {
            this.discogs.count = cached.count;
            this.discogs.success = true;
          }
        }

        this.calculate();

        var self = this;
        window.addEventListener('scroll', function () {
          self.showSticky = window.scrollY > 200;
        }, { passive: true });
      },

      switchTab: function (t) {
        this.tab = t;
        this.calculate();
      },

      calculate: function () {
        var d = this.detailed;
        var total, mmTotal, kgTotal;

        if (this.tab === 'detailed' && (d.lp + d.ep12 + d.lp10 + d.lp7 > 0)) {
          var heavyShare = Math.max(0, Math.min(100, d.pctHeavy)) / 100;
          var gateShare  = Math.max(0, Math.min(100, d.pctGate))  / 100;
          var lpReg  = d.lp * (1 - heavyShare - gateShare);
          var lpHvy  = d.lp * heavyShare;
          var lpGate = d.lp * gateShare;
          mmTotal = lpReg*SPINE_MM.lp + lpHvy*SPINE_MM.lp180 + lpGate*SPINE_MM.gate
                  + d.ep12*SPINE_MM.ep12 + d.lp10*SPINE_MM.lp10 + d.lp7*SPINE_MM.lp7;
          kgTotal = lpReg*WEIGHT_KG.lp + lpHvy*WEIGHT_KG.lp180 + lpGate*WEIGHT_KG.gate
                  + d.ep12*WEIGHT_KG.ep12 + d.lp10*WEIGHT_KG.lp10 + d.lp7*WEIGHT_KG.lp7;
          total = d.lp + d.ep12 + d.lp10 + d.lp7;
        } else if (this.tab === 'discogs' && this.discogs.count) {
          total = this.discogs.count;
          mmTotal = total * SPINE_MM.lp;
          kgTotal = total * WEIGHT_KG.lp;
        } else {
          total = this.quickCount || 0;
          mmTotal = total * SPINE_MM.lp;
          kgTotal = total * WEIGHT_KG.lp;
        }

        var meters = mmTotal / 1000;
        var tier = tierForCount(total);
        var matched = (PRODUCTS[tier.key] || []).slice(0, 3);

        this.result = {
          total: total,
          meters: meters,
          feet: meters * 3.28084,
          inches: Math.round(mmTotal / 25.4),
          kg: kgTotal,
          lbs: kgTotal * 2.20462,
          value: Math.round(total * VALUE_USD_PER_RECORD),
          tier: { key: tier.key, label: tier.label, units: tier.units, products: matched }
        };

        this.syncURL();
        this.renderViz();
      },

      // Render SVG storage viz (vanilla DOM — Alpine x-for fails inside <svg> namespace)
      renderViz: function () {
        var host = document.querySelector('[data-kts-viz]');
        if (!host) return;
        var r = this.result;
        if (!r || r.total === 0) { host.innerHTML = ''; return; }
        var units = Math.min(r.tier.units, 6);
        var W = 800, H = 320;
        var NS = 'http://www.w3.org/2000/svg';
        function el(tag, attrs) {
          var e = document.createElementNS(NS, tag);
          for (var k in attrs) e.setAttribute(k, attrs[k]);
          return e;
        }
        var svg = el('svg', {viewBox:'0 0 '+W+' '+H, preserveAspectRatio:'xMidYMid meet', class:'kts-tv__svg'});
        svg.style.width = '100%';
        svg.style.height = 'auto';
        svg.style.display = 'block';

        // Background & floor
        svg.appendChild(el('rect', {x:0,y:0,width:W,height:H,fill:'#F5F5F5'}));
        svg.appendChild(el('ellipse', {cx:W/2,cy:290,rx:340,ry:14,fill:'#1A1A1A','fill-opacity':'0.08'}));

        // Vinyl spine color palette (earthy + brand)
        var palette = ['#1A1A1A','#FFBD00','#3E2A1F','#8B6F47','#C4A484','#2B2B2B','#996B00','#5C4033'];
        var slot = 640 / units;
        var unitW = Math.min(110, slot - 12);

        for (var i = 0; i < units; i++) {
          var g = el('g', {transform: 'translate(' + (80 + i * slot) + ' 50)'});
          // Wood furniture body
          g.appendChild(el('rect', {x:0,y:0,width:unitW,height:200,fill:'#3E2A1F',stroke:'#1A1A1A','stroke-width':'2',rx:'2'}));
          // Inner wood highlight
          g.appendChild(el('rect', {x:3,y:3,width:unitW-6,height:194,fill:'#4A3525','fill-opacity':'0.45'}));
          // Shelf dividers (4 shelves = 3 lines)
          for (var s = 1; s < 4; s++) {
            g.appendChild(el('line', {x1:3,y1:s*50,x2:unitW-3,y2:s*50,stroke:'#1A1A1A','stroke-width':'1.5','stroke-opacity':'0.5'}));
          }
          // Vinyl spines per shelf
          var spineW = 3, gap = 1, step = spineW + gap;
          var nSpines = Math.floor((unitW - 8) / step);
          for (var shelf = 0; shelf < 4; shelf++) {
            var y0 = shelf * 50 + 6;
            for (var n = 0; n < nSpines; n++) {
              var x = 4 + n * step;
              g.appendChild(el('rect', {
                x:x, y:y0, width:spineW, height:40,
                fill: palette[(n + shelf * 3 + i) % palette.length],
                'fill-opacity':'0.9'
              }));
            }
          }
          // Pedestal base
          g.appendChild(el('rect', {x:-4,y:200,width:unitW+8,height:6,fill:'#1A1A1A'}));
          svg.appendChild(g);
        }

        // +N more badge
        if (r.tier.units > 6) {
          var bg = el('g', {});
          bg.appendChild(el('rect', {x:680,y:230,width:95,height:36,rx:18,fill:'#FFBD00'}));
          var mt = el('text', {x:727,y:254,'text-anchor':'middle','font-family':'Poppins, sans-serif','font-size':'14','font-weight':'600',fill:'#1A1A1A'});
          var moreSfx = (window.KTS_TOOLCALC_I18N && window.KTS_TOOLCALC_I18N.viz_more_suffix) || ' more';
          mt.textContent = '+' + (r.tier.units - 6) + moreSfx;
          bg.appendChild(mt);
          svg.appendChild(bg);
        }

        // Baseline + ticks
        svg.appendChild(el('line', {x1:80,y1:268,x2:720,y2:268,stroke:'#1A1A1A','stroke-width':'1.2'}));
        for (var t = 0; t <= 4; t++) {
          var tx = 80 + t * 160;
          svg.appendChild(el('line', {x1:tx,y1:264,x2:tx,y2:272,stroke:'#1A1A1A','stroke-width':'1'}));
        }
        // Caption (meters)
        var cap = el('text', {x:W/2,y:288,'text-anchor':'middle','font-family':'Poppins, sans-serif','font-size':'13','font-weight':'600',fill:'#1A1A1A'});
        var mSfx = (window.KTS_TOOLCALC_I18N && window.KTS_TOOLCALC_I18N.viz_total_suffix) || ' m total linear shelf space';
        cap.textContent = r.meters.toFixed(2) + mSfx;
        svg.appendChild(cap);
        // Sub-caption (records + config)
        var sub = el('text', {x:W/2,y:308,'text-anchor':'middle','font-family':'Poppins, sans-serif','font-size':'11',fill:'#6A6A6A'});
        var recSfx = (window.KTS_TOOLCALC_I18N && window.KTS_TOOLCALC_I18N.viz_records_suffix) || ' records · ';
        var cfgLbl = (window.KTS_TOOLCALC_I18N && window.KTS_TOOLCALC_I18N.viz_config_label) || 'configuration';
        sub.textContent = r.total.toLocaleString() + recSfx + r.tier.label + ' ' + cfgLbl;
        svg.appendChild(sub);

        host.innerHTML = '';
        host.appendChild(svg);
      },

      // Reflect current state into URL without reload (shareable)
      syncURL: function () {
        if (!window.history || !window.history.replaceState) return;
        var p = new URLSearchParams();
        p.set('tab', this.tab);
        if (this.tab === 'quick') {
          p.set('records', this.quickCount);
        } else if (this.tab === 'detailed') {
          var d = this.detailed;
          ['lp','ep12','lp10','lp7','pctHeavy','pctGate'].forEach(function (k) {
            if (d[k]) p.set(k, d[k]);
          });
        } else if (this.tab === 'discogs' && this.discogs.username) {
          p.set('discogs', this.discogs.username);
        }
        if (this.embed) p.set('embed', '1');
        var qs = p.toString();
        var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
        window.history.replaceState(null, '', newUrl);
      },

      // ---- Discogs public-collection loader ----
      loadFromDiscogs: function () {
        var user = (this.discogs.username || '').trim();
        if (!user) return;
        this.discogs.error = null;
        this.discogs.success = false;
        this.discogs.loading = true;

        // cache check (24h)
        var ckey = 'kts_discogs_' + user.toLowerCase();
        var cached = cacheGet(ckey);
        if (cached && cached.count) {
          this.discogs.count = cached.count;
          this.discogs.loading = false;
          this.discogs.success = true;
          this.tab = 'discogs';
          this.calculate();
          return;
        }

        var self = this;
        var url = 'https://api.discogs.com/users/' + encodeURIComponent(user) + '/collection/folders/0';
        // no User-Agent header in browser (forbidden); public endpoint accepts default
        fetch(url, { method: 'GET', headers: { 'Accept': 'application/json' } })
          .then(function (r) {
            if (r.status === 404) throw new Error('404');
            if (r.status === 401 || r.status === 403) throw new Error('private');
            if (r.status === 429) throw new Error('rate');
            if (!r.ok) throw new Error('http_' + r.status);
            return r.json();
          })
          .then(function (j) {
            var n = (j && typeof j.count === 'number') ? j.count : 0;
            if (!n) throw new Error('empty');
            cacheSet(ckey, { count: n });
            self.discogs.count = n;
            self.discogs.success = true;
            self.discogs.error = null;
            self.tab = 'discogs';
            self.calculate();
          })
          .catch(function (e) {
            var msg = tr('discogs_error_generic', 'Could not load that Discogs user. Check the username is public and correct.');
            if (e && e.message === '404')      msg = tr('discogs_error_404', 'No public collection found for that username. Make sure it is spelled correctly.');
            else if (e.message === 'private')  msg = tr('discogs_error_private', 'This collection is private. Set it to public in your Discogs settings to import.');
            else if (e.message === 'rate')     msg = tr('discogs_error_rate', 'Discogs is rate-limiting us. Wait a minute and try again.');
            else if (e.message === 'empty')    msg = tr('discogs_error_empty', 'That collection is empty or unavailable.');
            self.discogs.error = msg;
            self.discogs.success = false;
          })
          .then(function () { self.discogs.loading = false; });
      },

      // ---- PDF export (branded, pure jsPDF) ----
      exportPDF: function () {
        var self = this;
        if (!self.result || !self.result.total) {
          alert(tr('pdf_error_calc', 'Run a calculation first.'));
          return;
        }
        loadJsPdf().then(function (jsPDF) {
          try {
            self.$generatePdf(jsPDF);
          } catch (err) {
            console.error('[KTS PDF] gen error', err);
            alert(tr('pdf_error', 'Could not generate PDF. Try again.'));
          }
        }).catch(function (err) {
          console.error('[KTS PDF] load error', err);
          alert(tr('pdf_error', 'Could not load PDF exporter. Try again in a moment.'));
        });
      },

      // Build branded PDF with jsPDF primitives — bulletproof, no canvas
      $generatePdf: function (jsPDF) {
        var r = this.result;
        var doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
        var W = 210, H = 297, M = 18; // A4 + margins
        var y = M;

        // ---- Header band (yellow accent + brand) ----
        doc.setFillColor(26, 26, 26); // #1A1A1A
        doc.rect(0, 0, W, 24, 'F');
        doc.setFillColor(255, 189, 0); // #FFBD00
        doc.rect(0, 24, W, 2, 'F');

        doc.setTextColor(255, 189, 0);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(18);
        doc.text('KEEP THEM SPINNING', M, 15);

        doc.setTextColor(255, 255, 255);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        var today = new Date().toLocaleDateString(document.documentElement.lang || 'en', {
          year: 'numeric', month: 'long', day: 'numeric'
        });
        doc.text(today, W - M, 15, { align: 'right' });

        y = 38;

        // ---- Title ----
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(22);
        doc.text(tr('pdf_heading', 'Your Vinyl Storage Report'), M, y);
        y += 7;

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        doc.setTextColor(110, 110, 110);
        doc.text(tr('pdf_subheading', 'Generated by the KTS Vinyl Storage Calculator'), M, y);
        y += 10;

        // ---- Results summary table ----
        doc.setDrawColor(230, 228, 228);
        doc.setLineWidth(0.2);
        var rows = [
          [tr('pdf_label_records', 'Records'), r.total.toLocaleString()],
          [tr('pdf_label_space', 'Shelf space'),
            r.meters.toFixed(2) + ' m  ·  ' + r.inches + ' in  ·  ' + r.feet.toFixed(1) + ' ft'],
          [tr('pdf_label_tier', 'Tier'), r.tier.label],
          [tr('pdf_label_units', 'Units recommended'), String(r.tier.units)],
          [tr('pdf_label_value', 'Estimated collection value'), '$' + r.value.toLocaleString()]
        ];

        doc.setFontSize(11);
        rows.forEach(function (row) {
          doc.setTextColor(110, 110, 110);
          doc.setFont('helvetica', 'normal');
          doc.text(row[0], M, y);
          doc.setTextColor(26, 26, 26);
          doc.setFont('helvetica', 'bold');
          doc.text(row[1], W - M, y, { align: 'right' });
          y += 1.5;
          doc.line(M, y + 1, W - M, y + 1);
          y += 6;
        });

        y += 6;

        // ---- Recommended products ----
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(14);
        doc.text(tr('pdf_products_header', 'Recommended configuration'), M, y);
        y += 6;

        doc.setFillColor(245, 245, 245);
        doc.rect(M, y - 4, W - 2 * M, 8, 'F');
        doc.setFontSize(10);
        doc.setTextColor(26, 26, 26);
        doc.text('Product', M + 2, y + 1);
        doc.text('Capacity', M + 90, y + 1);
        doc.text('Price', W - M - 2, y + 1, { align: 'right' });
        y += 8;

        doc.setFont('helvetica', 'normal');
        doc.setFontSize(10);
        (r.tier.products || []).slice(0, 3).forEach(function (p) {
          doc.setTextColor(26, 26, 26);
          // Truncate long names to fit
          var name = p.name.length > 42 ? p.name.substring(0, 42) + '...' : p.name;
          doc.text(name, M + 2, y);
          doc.text(p.capacity + ' LPs', M + 90, y);
          doc.text('€' + p.price.toFixed(2), W - M - 2, y, { align: 'right' });
          y += 4;
          // URL row
          doc.setFontSize(8);
          doc.setTextColor(110, 110, 110);
          var url = window.location.origin + '/products/' + p.handle;
          doc.textWithLink(url.substring(0, 80), M + 2, y, { url: url });
          y += 4;
          doc.setLineWidth(0.1);
          doc.setDrawColor(230, 228, 228);
          doc.line(M, y, W - M, y);
          y += 4;
          doc.setFontSize(10);
        });

        y += 4;

        // ---- CTA block ----
        if (y > H - 50) { doc.addPage(); y = M; }
        doc.setFillColor(26, 26, 26);
        doc.rect(M, y, W - 2 * M, 32, 'F');
        doc.setFillColor(255, 189, 0);
        doc.rect(M, y, W - 2 * M, 2, 'F');

        doc.setTextColor(255, 189, 0);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(13);
        doc.text(tr('pdf_cta_header', 'Ready to upgrade your storage?'), W / 2, y + 11, { align: 'center' });

        doc.setTextColor(245, 245, 245);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
        doc.text(
          tr('pdf_cta_text', 'Designed in Spain · Quality-inspected in Madrid · Ships worldwide from Madrid'),
          W / 2, y + 18, { align: 'center' }
        );

        doc.setTextColor(255, 255, 255);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        var ctaUrl = tr('pdf_cta_url', 'keepthemspinning.com/pages/vinyl-storage-calculator');
        doc.text(ctaUrl, W / 2, y + 26, { align: 'center' });

        y += 40;

        // ---- Footer (page number + disclaimer) ----
        doc.setTextColor(150, 150, 150);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7);
        doc.text(
          'Estimates based on standard LP spine widths. Individual collections may vary.',
          M, H - 8
        );
        doc.text('keepthemspinning.com', W - M, H - 8, { align: 'right' });

        // ---- Save ----
        var fname = 'kts-vinyl-storage-' + r.total + '.pdf';
        doc.save(fname);
      },

      $buildPdfNode: function () {
        var r = this.result;
        var fmt = function (n, d) { return (d === undefined ? 1 : d) === 0 ? Math.round(n).toString() : n.toFixed(d); };
        var today = new Date().toLocaleDateString(document.documentElement.lang || 'en', { year: 'numeric', month: 'long', day: 'numeric' });
        var origin = window.location.origin;
        var productsRows = r.tier.products.map(function (p) {
          return '<tr>' +
            '<td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;">' + p.name + '</td>' +
            '<td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;text-align:right;">' + p.capacity + ' LPs</td>' +
            '<td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;text-align:right;">€' + p.price.toFixed(2) + '</td>' +
            '<td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;text-align:right;font-size:10px;color:#1A1A1A;">' + origin + '/products/' + p.handle + '</td>' +
          '</tr>';
        }).join('');

        var lblRecs = tr('pdf_label_records', 'Records');
        var lblSpace = tr('pdf_label_space', 'Shelf space');
        var lblUnits = tr('pdf_label_units', 'Units recommended');
        var lblTier = tr('pdf_label_tier', 'Tier');
        var lblValue = tr('pdf_label_value', 'Estimated collection value');
        var heading = tr('pdf_heading', 'Your Vinyl Storage Report');
        var subheading = tr('pdf_subheading', 'Generated by the KTS Vinyl Storage Calculator');
        var prodHeader = tr('pdf_products_header', 'Recommended configuration');
        var ctaHeader = tr('pdf_cta_header', 'Ready to upgrade your storage?');
        var ctaText = tr('pdf_cta_text', 'Designed in Spain · Quality-inspected in Madrid · Ships worldwide from Madrid');
        var ctaUrl = tr('pdf_cta_url', 'keepthemspinning.com/pages/vinyl-storage-calculator');

        var html =
          '<div style="font-family:Poppins,Arial,sans-serif;color:#1A1A1A;padding:20px;max-width:760px;">' +
            '<div style="border-bottom:3px solid #FFBD00;padding-bottom:12px;margin-bottom:18px;display:flex;justify-content:space-between;align-items:center;">' +
              '<div style="font-family:\'Roboto Condensed\',Arial,sans-serif;font-weight:700;font-size:22px;letter-spacing:1px;">KEEP THEM SPINNING</div>' +
              '<div style="font-size:11px;color:#6A6A6A;">' + today + '</div>' +
            '</div>' +
            '<h1 style="font-family:\'Roboto Condensed\',Arial,sans-serif;font-size:28px;margin:0 0 4px;color:#1A1A1A;">' + heading + '</h1>' +
            '<p style="font-size:12px;color:#6A6A6A;margin:0 0 20px;">' + subheading + '</p>' +
            '<table style="width:100%;border-collapse:collapse;margin-bottom:24px;font-size:13px;">' +
              '<tr><td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;color:#6A6A6A;width:50%;">' + lblRecs + '</td><td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;text-align:right;font-weight:600;">' + r.total + '</td></tr>' +
              '<tr><td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;color:#6A6A6A;">' + lblSpace + '</td><td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;text-align:right;font-weight:600;">' + fmt(r.meters, 2) + ' m / ' + r.inches + ' in / ' + fmt(r.feet, 1) + ' ft</td></tr>' +
              '<tr><td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;color:#6A6A6A;">' + lblTier + '</td><td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;text-align:right;font-weight:600;">' + r.tier.label + '</td></tr>' +
              '<tr><td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;color:#6A6A6A;">' + lblUnits + '</td><td style="padding:8px 6px;border-bottom:1px solid #E6E4E4;text-align:right;font-weight:600;">' + r.tier.units + '</td></tr>' +
              '<tr><td style="padding:8px 6px;color:#6A6A6A;">' + lblValue + '</td><td style="padding:8px 6px;text-align:right;font-weight:600;">$' + r.value.toLocaleString() + '</td></tr>' +
            '</table>' +
            '<h2 style="font-family:\'Roboto Condensed\',Arial,sans-serif;font-size:18px;margin:0 0 10px;color:#1A1A1A;">' + prodHeader + '</h2>' +
            '<table style="width:100%;border-collapse:collapse;margin-bottom:24px;font-size:12px;">' +
              '<thead><tr style="background:#F5F5F5;">' +
                '<th style="padding:8px 6px;text-align:left;font-weight:600;">Product</th>' +
                '<th style="padding:8px 6px;text-align:right;font-weight:600;">Capacity</th>' +
                '<th style="padding:8px 6px;text-align:right;font-weight:600;">Price</th>' +
                '<th style="padding:8px 6px;text-align:right;font-weight:600;">Link</th>' +
              '</tr></thead>' +
              '<tbody>' + productsRows + '</tbody>' +
            '</table>' +
            '<div style="background:#1A1A1A;color:#FFFFFF;padding:16px;text-align:center;border-radius:4px;">' +
              '<div style="font-family:\'Roboto Condensed\',Arial,sans-serif;font-size:14px;margin-bottom:6px;color:#FFBD00;">' + ctaHeader + '</div>' +
              '<div style="font-size:11px;opacity:.92;margin-bottom:8px;">' + ctaText + '</div>' +
              '<div style="font-size:12px;font-weight:600;">' + ctaUrl + '</div>' +
            '</div>' +
          '</div>';

        var div = document.createElement('div');
        div.style.cssText = 'background:#FFFFFF;width:800px;';
        div.innerHTML = html;
        return div;
      },

      // ---- Share current result ----
      shareResult: function () {
        var p = new URLSearchParams(window.location.search);
        p.delete('embed');
        var url = window.location.origin + window.location.pathname + '?' + p.toString();
        var title = tr('share_title', 'Vinyl Storage Calculator');
        var text = tr('share_text', 'I need space for ' + this.result.total + ' records. Here\'s the KTS match:');
        if (navigator.share) {
          navigator.share({ title: title, text: text, url: url }).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            alert(tr('share_copied', 'Link copied to clipboard'));
          }, function () { prompt(tr('share_prompt', 'Copy this link:'), url); });
        } else {
          prompt(tr('share_prompt', 'Copy this link:'), url);
        }
      }
    };
  }

  window.ktsStorageCalc = ktsStorageCalc;
})();
